import type { Language } from "./languages";
import { localizedText } from "./localization";
export const DEFAULT_IMAGE_MODEL_ID = "@cf/black-forest-labs/flux-2-klein-9b";

export interface ImageModelInfo {
  id: string;
  name: string;
  provider: "Black Forest Labs" | "Leonardo";
  summary: Record<Language, string>;
  price: Record<Language, string>;
  profile: "balanced" | "quality" | "design" | "prompt";
}

export const IMAGE_MODELS: readonly ImageModelInfo[] = [
  {
    id: DEFAULT_IMAGE_MODEL_ID,
    name: "FLUX.2 Klein 9B",
    provider: "Black Forest Labs",
    summary: localizedText("The best balance of speed and quality for everyday creation"),
    price: localizedText("$0.015 / first megapixel"),
    profile: "balanced",
  },
  {
    id: "@cf/black-forest-labs/flux-2-dev",
    name: "FLUX.2 Dev",
    provider: "Black Forest Labs",
    summary: localizedText("Prioritizes detail and realism with a slower render"),
    price: localizedText("Priced by tile and step"),
    profile: "quality",
  },
  {
    id: "@cf/leonardo/lucid-origin",
    name: "Lucid Origin",
    provider: "Leonardo",
    summary: localizedText("Excellent for visual design, product shots, and text"),
    price: localizedText("$0.007 / 512px tile"),
    profile: "design",
  },
  {
    id: "@cf/leonardo/phoenix-1.0",
    name: "Phoenix 1.0",
    provider: "Leonardo",
    summary: localizedText("Strong prompt adherence with coherent rendered text"),
    price: localizedText("$0.0058 / 512px tile"),
    profile: "prompt",
  },
] as const;

const imageModelIds = new Set(IMAGE_MODELS.map((model) => model.id));

export const isImageModelId = (value: unknown): value is string =>
  typeof value === "string" && imageModelIds.has(value);

export const getImageModel = (modelId: string): ImageModelInfo =>
  IMAGE_MODELS.find((model) => model.id === modelId) ?? IMAGE_MODELS[0];
